import React from 'react';
import shape from '../../images/shapes/shape_poligon.svg';

const Testimonials = () => {
    return (
        <section className="testimonials_section section_space section_decoration">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="ico_heading_block" data-aos="fade-up" data-aos-duration="600">
                            <h2 className="heading_text mb-4 text-center">
                                Отзывы
                            </h2>
                        </div>
                        <div className="row">
                            <div className="col-lg-4" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100" >
                                <div className="testimonial_item">
                                    <div className="testimonial_content">
                                        <p className="info_description" style={{ fontFamily: 'Palqa', fontSize: 16 }}>
                                            "Сотрудничество с этой командой стало для нас ключевым шагом: продажи выросли в 3 раза всего за два месяца. Ребята не просто сливают трафик, а реально понимают бизнес-задачи."
                                        </p>
                                    </div>
                                    <div className="testimonial_author mt-3">
                                        <h4 className="author_name">Александр П.</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4" data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
                                <div className="testimonial_item">
                                    <div className="testimonial_content">
                                        <p className="info_description" style={{ fontFamily: 'Palqa', fontSize: 16 }}>
                                            "Работаем больше года, и я могу сказать, что это одна из самых ответственных и сильных команд. Стабильный объём трафика, честные выплаты и умение находить нестандартные креативы."
                                        </p>
                                    </div>
                                    <div className="testimonial_author mt-3">
                                        <h4 className="author_name">Мария Л.</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4" data-aos="fade-up" data-aos-duration="600" data-aos-delay="300">
                                <div className="testimonial_item">
                                    <div className="testimonial_content">
                                        <p className="info_description" style={{ fontFamily: 'Palqa', fontSize: 16 }}>
                                            "Наконец-то встретил команду, которая не боится экспериментов. Благодаря их подходу наш интернет-магазин вышел на новые рынки."
                                        </p>
                                    </div>
                                    <div className="testimonial_author mt-3">
                                        <h4 className="author_name">Игорь К.</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="decoration_item shape_shadow_1">
                <img src={shape} alt="Shape Color Shadow" />
            </div>
            <div className="decoration_item shape_shadow_2">
                <img src={shape} alt="Shape Color Shadow" />
            </div>
        </section>
    );
};

export default Testimonials;
